import View from "./view";
import Presenter from "./presenter";
import { ConnectComponent2 } from "util";

const states = [
  {
    name: "app.signup",
    url: "/cadastro",
    views: {
      "content@app": ConnectComponent2(View, Presenter)
    }
  }
];

export { states };



// WEBPACK FOOTER //
// ./src/components/app/sign-up/index.js